interface ICheckIconProps {
  width?: string;
  height?: string;
  color?: string;
}

const CheckIcon = ({ width = '16', height = '16', color = '#00BA00' }: ICheckIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    width={width}
    height={height}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 7.875C0 3.52617 3.52617 0 7.875 0C12.2238 0 15.75 3.52617 15.75 7.875C15.75 12.2238 12.2238 15.75 7.875 15.75C3.52617 15.75 0 12.2238 0 7.875ZM2.25 7.875L6.75 12.375L13.5 5.625L11.918 4.04297L6.75 9.21094L3.83203 6.29297L2.25 7.875Z"
      fill={color}
    />
  </svg>
);

export default CheckIcon;
